import { withNavBar } from '../../shared/NavBar/NavBar';
import React, { useEffect, useState } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import i18n from "i18n-js";
import Localization from '../../../shared/Localization';
import FrequentlyAskedQuestions from '../frequentlyAskedQuestions/FrequentlyAskedQuestions';
import { ContentPhoto } from '../../shared/ContentPhoto/ContentPhoto';
import IdentificationGuide from '../identificationGuide/IdentificationGuide';

import './HelpAndInfo.scss';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant='h6'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function HelpAndInfo() {
  const [local, setLocal] = useState<typeof i18n | null>(null);
  const [currTab, setCurrTab] = React.useState(0);

  useEffect(() => {
    const setNewLocal = async () => {
      const newLocal = await Localization("en");
      setLocal(newLocal);
    };

    setNewLocal();
  }, []);


  function handleChange(event: any, newValue: any) {
    setCurrTab(newValue);
  }

  return (
    <div className='help-and-info'>
      <h4 className='main-title'>Help and Info</h4>
      <div className='tabs-wrapper'>
        <AppBar
          position='sticky'
          color='default'
          style={{
            transition: 'all 0.1s',
            width: '100%',
          }}
        >
          <Tabs
            className='tabs'
            value={currTab}
            onChange={handleChange}
            indicatorColor='primary'
            textColor='primary'
            variant='fullWidth'
            data-testid='help-and-info-tabs'
          >
            <Tab label='Campus Habitat Maps' className='tab-label' />
            <Tab label='Visual Identification Guide' className='tab-label' />
            <Tab label='FAQ' className='tab-label' />
            <Tab label='Contact Support' className='tab-label' />
            <Tab label='About iTrack Habitat' className='tab-label' />
          </Tabs>
        </AppBar>

        <TabPanel value={currTab} index={0}>
          Know where habitats are located
          <Grid container spacing={10}>
            <Grid item lg>
              <p>Chesterfield, MO</p>
              <ContentPhoto 
                url={'habitat-maps-chesterfield-1.png'} 
                height={'auto'} 
              />
            </Grid>
            <Grid item lg>
              <p>Creve Coeur, MO</p>
              <ContentPhoto 
                url={'habitat-maps-creve-coeur-1.png'} 
                height={'auto'} 
              />
              <ContentPhoto 
                url={'habitat-maps-creve-coeur-2.png'} 
                height={'auto'} 
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={currTab} index={1}>
          <IdentificationGuide />
        </TabPanel>
        <TabPanel value={currTab} index={2}>
          <FrequentlyAskedQuestions />
        </TabPanel>
        <TabPanel value={currTab} index={3}>
        <p>{local?.t("contactSupport.sendUsAnEmail")} <a href = "mailto: itrack.habitat@bayer.com">itrack.habitat@bayer.com</a></p>
        </TabPanel>
        <TabPanel value={currTab} index={4}>
          <strong>App Version:  1.0.0</strong>
          <p>{local?.t("aboutItrack.description")}</p>
        </TabPanel>
      </div>
    </div>
  );
}

export default withNavBar(HelpAndInfo, true);
